import React from "react";

import { TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import { FieldValueType } from "@safetyculture/s12-apis-connect-web/s12/typefield/v1/field_pb";
import { Attribute } from "@safetyculture/s12-apis-connect-web/s12/users/userattribute/v1/attribute_pb";

import mainStyles from "../../../styles";
import { DateType } from "./attribute-types/date-type";
import { SelectType } from "./attribute-types/select-type";
import { StringType } from "./attribute-types/string-type";
import { UserType } from "./attribute-types/user-type";
import {
  getRawDateAttributeValues,
  getRawStringAttributeValues,
} from "./utils";

type UserAttributesTableRowProps = {
  attribute: Attribute;
  regionCode: string;
  roleId: string;
};

export const UserAttributesTableRow = (props: UserAttributesTableRowProps) => {
  const { attribute, regionCode, roleId } = props;
  const classes = mainStyles();
  return (
    <TableRow data-testid="user-attribute-table-row">
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {attribute.fieldName}
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {renderAttributeComponent(attribute, regionCode, roleId)}
      </TableCell>
    </TableRow>
  );
};

const renderAttributeComponent = (
  attribute: Attribute,
  regionCode: string,
  roleId: string
) => {
  switch (attribute.valueType) {
    case FieldValueType.STRING:
      const stringValues = getRawStringAttributeValues(
        attribute.attributeValues
      );
      return <StringType values={stringValues} />;
    case FieldValueType.TIMESTAMP:
      const dateValues = getRawDateAttributeValues(attribute.attributeValues);
      return <DateType values={dateValues} />;
    case FieldValueType.USER_ID:
      const userIds = getRawStringAttributeValues(attribute.attributeValues);
      return (
        <UserType userIds={userIds} roleId={roleId} regionCode={regionCode} />
      );
    case FieldValueType.SELECT:
      const optionValues = getRawStringAttributeValues(
        attribute.attributeValues
      );
      return (
        <SelectType
          values={optionValues}
          fieldId={attribute.fieldId}
          regionCode={regionCode}
          roleId={roleId}
        />
      );
    default:
      return null;
  }
};
